/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Preview_PhotosInputs */

const cs_portals_preview_photos = /** @type {(inputs: Portals_Preview_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografie k exportu`)
};

const en_portals_preview_photos = /** @type {(inputs: Portals_Preview_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos for export`)
};

/**
* | output |
* | --- |
* | "Photos for export" |
*
* @param {Portals_Preview_PhotosInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_preview_photos = /** @type {((inputs?: Portals_Preview_PhotosInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Preview_PhotosInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_preview_photos(inputs)
	return cs_portals_preview_photos(inputs)
});